
// import './App.css';
// importing all components
import Navigation from "./components/Navigation"
import SocialPostWriter from "./components/SocialPostWriter"
import ProductDescription from "./components/ProductDescription"
import ColdEmail from "./components/ColdEmail"
import Home from "./components/Home"
import Copyright from "./components/Copyright"
import SeoContent from "./components/SeoContent"

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'

function App() {
  return (
    <Router>
    <div className="App">
    <Navigation/>
    <Routes>
    <Route path="/" exact element ={<Home/>} />
    <Route path="cold-email" exact element ={<ColdEmail/>} />
    <Route path="social-post-writer" exact element ={<SocialPostWriter/>} />
    <Route path="product-description-writer" exact element ={<ProductDescription/>} />
    <Route path="seo-content-writer" exact element ={<SeoContent/>} />
    <Route path="/linkedin-post-writer" exact element ={<SocialPostWriter/>} /> //redirecting
    </Routes>
    <Copyright/>
    </div>
    </Router>

  );
}

export default App;
